import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";

@Component({
  selector: "app-cold-calls-sheets",
  templateUrl: "./cold-calls-sheets.component.html",
  styleUrls: ["./cold-calls-sheets.component.css"],
})
export class ColdCallsSheetsComponent implements OnInit {

  filesForm: FormGroup;
  sheets: any = [
    {
      id: 1,
      name: 'sasa',
      contacts: 12,
      assigned_contacts: 10,
      not_assigned_contacts: 2,
      created_at: '12-10-2020'
    }
  ]

  constructor(
    private formBuilder: FormBuilder,
    private slimLoadingBarService: SlimLoadingBarService,
    private leadsService: LeadsService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.filesForm = this.formBuilder.group({
      sheet_name: [null, Validators.required],
      file_name: [null, Validators.required],
      file: [null, Validators.required],
    });
  }

  ngOnInit() {}

  importSheet(modal) {
    const payload = this.filesForm.value;
    if (this.filesForm.valid) {
      modal.close();
      this.slimLoadingBarService.start();
      this.leadsService.uploadContactsSheet(payload).subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          swal("Success", "Uploaded contacts sheet successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
    }
  }

  handleSheetExcel(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.filesForm.get("file_name").setValue(file.name);
        this.filesForm
          .get("file")
          .setValue((reader.result as any).split(",")[1]);
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cold-calls-sheets/cold-calls-sheets.component.ts